import React from "react";
import { Alert, Grid, GridItem } from '@sainsburys-tech/fable';
import { AlertCircleFilled } from '@sainsburys-tech/icons'
import ButtonWithApiCall from "../ButtonWithApiCall";
import PropTypes from "prop-types";

const ManagersOverrideBanner = props => (
  <div className="fable:pb-4 fable:pt-4">
    <Alert 
      status="warning"
      isOpen={true}
      key={"managersOverride"}
      leadingIcon={<AlertCircleFilled className="cb-c-managers-override-banner__error-img  -fable:mr-6" />}
    >
      <Grid cols={3} gap="md">
        <GridItem colSpan={2}>
          {props.children}
        </GridItem>
        <GridItem colSpan={1} className="fable:text-right">
          <ButtonWithApiCall
            type="submit"
            managersOverrideButton
            onClick={() => props.onSubmit()}
            savingMessage="Disabling managers override"
            useInlineError
            onComplete={props.onSaveComplete}
          />
        </GridItem>
      </Grid>
    </Alert>
  </div>
);

ManagersOverrideBanner.propTypes = {
  onSubmit: PropTypes.func,
  onSaveComplete: PropTypes.func
};

export default ManagersOverrideBanner;
